import React from "react";
import { Route } from "react-router-dom";

import AdminDashboardLayout from "../../AdminLayout/AdminDashboardLayout/AdminDashboardLayout";
import ADAllTask from "../Pages/ADAllTasks";
import ADAssignedTask from "../Pages/ADAssignedTask";
import ADInProgressTask from "../Pages/ADInProgressTask";
import ADCompletedTask from "../Pages/ADCompletedTask";
import ADReopenTask from "../Pages/ADReopenTask"
import ADHoldTask from "../Pages/ADHoldTask"
import ADClosedTask from "../Pages/ADClosedTask";

export const ADTaskRoutes = (
  <>
    <Route path="/Admin/Task/All-Tasks" element={<AdminDashboardLayout />}>
      <Route index element={<ADAllTask />} />
    </Route>

    <Route path="/Admin/Task/Assigned-Task" element={<AdminDashboardLayout />}>
      <Route index element={<ADAssignedTask />} />
    </Route>

    <Route path="/Admin/Task/In-Progress-Task" element={<AdminDashboardLayout />}>
      <Route index element={<ADInProgressTask />} />
    </Route>

     <Route path="/Admin/Task/Completed-Task" element={<AdminDashboardLayout />}>
      <Route index element={<ADCompletedTask />} />
    </Route>

    <Route path="/Admin/Task/Reopen-Task" element={<AdminDashboardLayout />}>
      <Route index element={<ADReopenTask />} />
    </Route>

     <Route path="/Admin/Task/Hold-Task" element={<AdminDashboardLayout />}>
      <Route index element={<ADHoldTask />} />
    </Route>

    <Route path="/Admin/Task/Closed-Task" element={<AdminDashboardLayout />}>
      <Route index element={<ADClosedTask />} />
    </Route>
    
  </>
);